import { render, staticRenderFns } from "./GeofenceEventsSettings.vue?vue&type=template&id=560d4cf7&scoped=true&"
import script from "./GeofenceEventsSettings.vue?vue&type=script&lang=js&"
export * from "./GeofenceEventsSettings.vue?vue&type=script&lang=js&"
import style0 from "./GeofenceEventsSettings.vue?vue&type=style&index=0&id=560d4cf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560d4cf7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('560d4cf7')) {
      api.createRecord('560d4cf7', component.options)
    } else {
      api.reload('560d4cf7', component.options)
    }
    module.hot.accept("./GeofenceEventsSettings.vue?vue&type=template&id=560d4cf7&scoped=true&", function () {
      api.rerender('560d4cf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/GeofenceEventsSettings.vue"
export default component.exports